import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;

  > h2 {
    width: 100%;
    margin: 0 14px 24px;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) { 
    flex-wrap: nowrap;
    padding: 12.5px 0;

    > h2 {
      max-width: 196px;
      margin: 0 128px 0 14px;
    }
  }
`

const ListPlan = styled.div` 
  flex-wrap: nowrap;
  width: 100%;

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) { 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
  }
`

const ButtonMobile = styled.div` 
  background-color: #fff;
  bottom: 0;
  box-shadow: 2px -8px 20px 0 rgb(0 0 0 / 6%);
  justify-content: space-between;
  left: 0;
  padding: 10px;
  position: fixed;
  right: 0;
  z-index: 5;

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) { 
    display: none;
  }
`

export { ButtonMobile, Container, ListPlan }
